import { DIAGNOSIS_UNLOCK_ACTIONS } from "./Steps/DiagnosisUnlockFlow/diagnosisUnlockChrome";

/** User rejected goal creation — do not save a goal; end onboarding and guide them to Plan */
export const PRESENT_RISK_REJECTED_TOOL_MESSAGE =
  "The user declined to create a goal. Do not create or save any goal.  Respond warmly and reassure them that it's completely okay not to unlock right now — they can return to the Plan page anytime to continue unlocking their full Plan whenever they're ready. Then gently invite them to head over to the Brief tab to explore in the meantime. Keep the tone calm, non-pressuring, and steward-like";

/** User accepted the draft — resume chat and proceed to field completion */
export const PRESENT_RISK_ACCEPTED_TOOL_MESSAGE =
  "The user accepted this draft. Please proceed to the next step.";

/** Non-member clicked unlock — guide them to become a member, then continue to Plan to set up a goal */
export const PRESENT_RISK_UNLOCK_FULL_PLAN_TOOL_MESSAGE =
  "The user accepted this draft. Please proceed to the next step.";

const PRESENT_RISK_REJECT_ACTIONS: readonly string[] = [
  DIAGNOSIS_UNLOCK_ACTIONS.step1Exit,
  DIAGNOSIS_UNLOCK_ACTIONS.reportClose,
];

const PRESENT_RISK_ACCEPT_ACTIONS: readonly string[] = [
  DIAGNOSIS_UNLOCK_ACTIONS.setupGoal,
];

/** Return a tool message for the diagnosis modal terminal action; null when no feedback is needed */
export const getPresentRiskToolMessageForAction = (
  action: string,
): string | null => {
  if (PRESENT_RISK_REJECT_ACTIONS.includes(action)) {
    return PRESENT_RISK_REJECTED_TOOL_MESSAGE;
  }

  if (PRESENT_RISK_ACCEPT_ACTIONS.includes(action)) {
    return PRESENT_RISK_ACCEPTED_TOOL_MESSAGE;
  }

  return null;
};
